export const API_ENDPOINTS = {
  CLOSE_CONTACT_BY_INTERVAL: `/close-contact/interval`,
  CLOSE_CONTACT_BY_USER: `/close-contact/user`,
  USERS: `/users`
}
